import { OPENAI_TO_LANGCHAIN_ROLE_MAP, role } from '../types/instructions';
function isConvertedPrompt(instruction) {
    return !!instruction?.type && !instruction?.role;
}
export function openAiInstructionToLangchainPrompt(instructions) {
    return instructions.map((instruction) => {
        if (isConvertedPrompt(instruction)) {
            return instruction;
        }
        const { role: currentRole, ...instructionWithoutRole } = instruction;
        // Determine the new type:
        // 1. If it's a legacy role (user/assistant), map it.
        // 2. Otherwise (system/tool), keep the current role string as the new type.
        const newType = OPENAI_TO_LANGCHAIN_ROLE_MAP[currentRole] ?? currentRole;
        return {
            ...instructionWithoutRole,
            type: newType,
        };
    });
}
export const ROLE_ICON_MAP = {
    [role.system]: 'ideas-sparkle-ai',
    [role.human]: 'user-default',
    [role.ai]: 'message-sparkle-ai',
    [role.variable]: 'restore',
    [role.shortTermMemory]: 'save-disk'
};
